export const environment = {
  production: false,
  swapId: true,
  apiUrl: 'https://dev.autoservicios1.bbva.com/v01',
  bbvaSso: 'https://dev-bbva-launcher.appspot.com/s/to/foodhelp?target=',
  certificatesUrl: 'https://dev.autocertificados.bbva.com',
};
